/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { ownersControllerCreate } from "./ownersControllerCreate";
import { ownersControllerFindAll } from "./ownersControllerFindAll";
import { ownersControllerFindOne } from "./ownersControllerFindOne";
import { ownersControllerRemove } from "./ownersControllerRemove";
import { ownersControllerUpdate } from "./ownersControllerUpdate";

export function ownersService() {
  return { ownersControllerCreate, ownersControllerFindAll, ownersControllerFindOne, ownersControllerUpdate, ownersControllerRemove }
}